import { CART_GENERAL_DISCOUNT } from 'constants/api-paths'
import request from './request'
import { formatError } from './error'

export const requestGeneralDiscount = async (params) => {
  const response = await request.patch(CART_GENERAL_DISCOUNT, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))

  return response
}
